"use strict";
/*
These filter options are static right now until we can get brand treez products into a catalog,
at that point we can use the api call to get unique list of features by the catalog and not have
them being static like this.

The reason they are stored here, is for use across services like SellTreez, PlanTreez, and BrandTreez.
Their originate from BrandTreez but if we store them here, if we need to make changes we can do so in one place.

The hope again is to deprecate when we compile brand products into catalogs.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandTreezGeneralAttributeOptions = exports.brandTreezIngredientOptions = exports.brandTreezEffectOptions = exports.brandTreezFlavorOptions = void 0;
exports.brandTreezFlavorOptions = [
    `Acrid`,
    `Berry`,
    `Citrus`,
    `Clove`,
    `Creamy`,
    `Earthy`,
    `Floral`,
    `Fresh`,
    `Fruity`,
    `Fuel`,
    `Grass`,
    `Lemon`,
    `Licorice`,
    `Mineral`,
    `Minty`,
    `Nutty`,
    `Peppery`,
    `Pine`,
    `Sharp`,
    `Sour`,
    `Spicy`,
    `Sweet`,
    `Vanilla`,
    `Vegetal`,
    `Woody`,
];
exports.brandTreezEffectOptions = [
    `Anxiety`,
    `Creative`,
    `Energetic`,
    `Euphoric`,
    `Focused`,
    `Happy`,
    `Hungry`,
    `Lazy`,
    `Pain Relieving`,
    `Relaxed`,
    `Sleepy`,
    `Uplifted`,
];
exports.brandTreezIngredientOptions = [
    `Baking Powder`,
    `Butter`,
    `Cacao`,
    `Chocolate`,
    `Coconut Oil`,
    `Coffee`,
    `Corn`,
    `Eggs`,
    `Flour`,
    `Fruit`,
    `Gelatin`,
    `Nuts`,
    `Oil`,
    `Salt`,
    `Sugar`,
    `Vanilla`,
];
exports.brandTreezGeneralAttributeOptions = [
    `Alcohol Extraction`,
    `All-Natural`,
    `Alpha-bisabolol`,
    `Borneol`,
    `Butane Extraction`,
    `CO2 Extraction`,
    `Camphene`,
    `Caryophyllene`,
    `Delta 3 Carene`,
    `Eucalyptol`,
    `Geraniol`,
    `Humulene`,
    `Hydro`,
    `Indoor`,
    `Limonene`,
    `Linalool`,
    `Myrcene`,
    `Nerolidol`,
    `Organic`,
    `Phytol`,
    `Pinene`,
    `Regenerative`,
    `Soil`,
    `Solvent-Free`,
    `Sugar-Free`,
    `Sun-Grown`,
    `Sustainable`,
    `Terpineol`,
    `Valencene`,
    `Vegan`,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnJhbmRUcmVlei5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9CcmFuZFRyZWV6LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTs7Ozs7Ozs7O0VBU0U7OztBQUVXLFFBQUEsdUJBQXVCLEdBQUc7SUFDbkMsT0FBTztJQUNQLE9BQU87SUFDUCxRQUFRO0lBQ1IsT0FBTztJQUNQLFFBQVE7SUFDUixRQUFRO0lBQ1IsUUFBUTtJQUNSLE9BQU87SUFDUCxRQUFRO0lBQ1IsTUFBTTtJQUNOLE9BQU87SUFDUCxPQUFPO0lBQ1AsVUFBVTtJQUNWLFNBQVM7SUFDVCxPQUFPO0lBQ1AsT0FBTztJQUNQLFNBQVM7SUFDVCxNQUFNO0lBQ04sT0FBTztJQUNQLE1BQU07SUFDTixPQUFPO0lBQ1AsT0FBTztJQUNQLFNBQVM7SUFDVCxTQUFTO0lBQ1QsT0FBTztDQUNWLENBQUE7QUFFWSxRQUFBLHVCQUF1QixHQUFHO0lBQ25DLFNBQVM7SUFDVCxVQUFVO0lBQ1YsV0FBVztJQUNYLFVBQVU7SUFDVixTQUFTO0lBQ1QsT0FBTztJQUNQLFFBQVE7SUFDUixNQUFNO0lBQ04sZ0JBQWdCO0lBQ2hCLFNBQVM7SUFDVCxRQUFRO0lBQ1IsVUFBVTtDQUNiLENBQUE7QUFFWSxRQUFBLDJCQUEyQixHQUFHO0lBQ3ZDLGVBQWU7SUFDZixRQUFRO0lBQ1IsT0FBTztJQUNQLFdBQVc7SUFDWCxhQUFhO0lBQ2IsUUFBUTtJQUNSLE1BQU07SUFDTixNQUFNO0lBQ04sT0FBTztJQUNQLE9BQU87SUFDUCxTQUFTO0lBQ1QsTUFBTTtJQUNOLEtBQUs7SUFDTCxNQUFNO0lBQ04sT0FBTztJQUNQLFNBQVM7Q0FDWixDQUFBO0FBRVksUUFBQSxpQ0FBaUMsR0FBRztJQUM3QyxvQkFBb0I7SUFDcEIsYUFBYTtJQUNiLGlCQUFpQjtJQUNqQixTQUFTO0lBQ1QsbUJBQW1CO0lBQ25CLGdCQUFnQjtJQUNoQixVQUFVO0lBQ1YsZUFBZTtJQUNmLGdCQUFnQjtJQUNoQixZQUFZO0lBQ1osVUFBVTtJQUNWLFVBQVU7SUFDVixPQUFPO0lBQ1AsUUFBUTtJQUNSLFVBQVU7SUFDVixVQUFVO0lBQ1YsU0FBUztJQUNULFdBQVc7SUFDWCxTQUFTO0lBQ1QsUUFBUTtJQUNSLFFBQVE7SUFDUixjQUFjO0lBQ2QsTUFBTTtJQUNOLGNBQWM7SUFDZCxZQUFZO0lBQ1osV0FBVztJQUNYLGFBQWE7SUFDYixXQUFXO0lBQ1gsV0FBVztJQUNYLE9BQU87Q0FDVixDQUFBIn0=